import React, { useState, useEffect, useRef} from 'react';
import Tab2 from "./Tab"
import CurrentTab from "./CurrentTab"
import TabDetail from "./TabDetail"
import MobileTab from "./MobileTab"
import MobilePanel from "./MobilePanel"
import "./homepage.scss";
import axios from 'axios';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles, makeStyles  } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Settings from "../../components/Homepage/Settings"
import ForecastPrintable from "./ForecastPrintable"
import BlockRadar from "./blockRadar"
import BlockSatellite from "./blockSatellite"
import BlockWindDataMap from "./blockWindDataMap"
import BlockTideTimes from "./blockTidesTimes"
import BlockSeaStateMorning from "./blockSeaStateMorning"
import BlockSeaStateAfternoon from './blockSeaStateAfternoon';
import Button from '@material-ui/core/Button';
import Loading from "../../pages/loading"
import Hidden from '@material-ui/core/Hidden';
import { Link } from "gatsby";

const defaultState = {
  windValue: 'Beaufort',
  tempValue: 'Celsius'
}
export const MenuContext = React.createContext(defaultState);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box className="tabpanel">
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: "center",
    margin:"100px 0 100px 0",
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
}));

const BlockSection = (props) => {
  return (
    <section id="tideWind" style={{padding:"0 24px 0 24px"}}>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={4} className="images">
                <BlockRadar />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} className="images">
                <BlockSatellite />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} className="images"> 
                <BlockWindDataMap />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} className="images">
            <BlockTideTimes title={props.title}/> 
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} className="images">
              <BlockSeaStateMorning/>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} className="images"> 
              <BlockSeaStateAfternoon/>
            </Grid>
        </Grid>
      </section>
  )
}


const Homepage = (props) => {
  const mobileVP = useMediaQuery('(max-width:600px)');
  const settingsMQ = useMediaQuery('(max-width:959px)');
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [day1, setDay1] = useState([]);
  const [day2, setDay2] = useState([]);
  const [day3, setDay3] = useState([]);
  const [day4, setDay4] = useState([]);
  const [day5, setDay5] = useState([]);
  const [day6, setDay6] = useState([]);

  const [forecastTimes, setForeCaseTimes] = useState("");
  const [jerseyFeed, setJerseyFeed] = useState(process.env.MET_JSYFORECAST)
  const [guernseyFeed, setGuernseyFeed] = useState(process.env.MET_GSYFORECAST)
  const [error, setError] = useState(false)

  // const classes = useStyles();

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };



  var title = ""
  if (props.mode==="jersey")
  {
    title ="Jersey weather";
  }
  else {
    title ="Guernsey weather";
  }

  let tempVar = "Celsius";
  let winVar = "Beaufort";
  if (typeof window !== 'undefined') {
    if (typeof(localStorage.getItem("Temperature")) !== "undefined") {
      if (localStorage.getItem("Temperature") !== null)
        tempVar = localStorage.getItem("Temperature");
    }
    if (typeof(localStorage.getItem("WindSpeed")) !== "undefined") {
      if (localStorage.getItem("WindSpeed") !== null)
        winVar = localStorage.getItem("WindSpeed");
    }
  }
  const [windValue, setWindValue] = useState(winVar);
  const [tempValue, setTempValue] = useState(tempVar);

  const handleSettingChange = (windValueEvent, tempValueEvent) => {
    setWindValue(windValueEvent);
    setTempValue(tempValueEvent);
  }
  //console.log(winVar);

  useEffect(() => {
    const fetchData = async () => {
      setError(false)
      setLoading(true)
      try {
        const result = await axios(
          props.mode === "jersey" ? jerseyFeed : guernseyFeed
        )
        if (props.mode === "jersey" && jerseyFeed.length && jerseyFeed !== null) {
        setData(result.data);
        setDay1(result.data.forecastDay[0]);
        setDay2(result.data.forecastDay[1]);
        setDay3(result.data.forecastDay[2]);
        setDay4(result.data.forecastDay[3]);
        setDay5(result.data.forecastDay[4]);
        setDay6(result.data.forecastDay[5]);
        setForeCaseTimes(result.data.forecastTime.replace(/ /g,''));
        setLoading(false);
        } else if (props.mode === "guernsey" && guernseyFeed.length && guernseyFeed !== null) {
        setData(result.data);
        setDay1(result.data.forecastDay[0]);
        setDay2(result.data.forecastDay[1]);
        setDay3(result.data.forecastDay[2]);
        setDay4(result.data.forecastDay[3]);
        setDay5(result.data.forecastDay[4]);
        setDay6(result.data.forecastDay[5]);
        setForeCaseTimes(result.data.forecastTime.replace(/ /g,''));
        setLoading(false);
        } 
      }
      catch (error) {
        setError(true)
        console.log(error);
        setLoading(false);
      }
    }
      fetchData();
  },[jerseyFeed, guernseyFeed])
   
const WeatherTabs = withStyles({
  indicator: {
    display: 'flex',
    alignItems:'bottom',
    backgroundColor: 'transparent',
    '& > span': {
      display:"none",
      marginLeft:"12px",
      width: '497px',
      backgroundColor: '#b60011',
    },
  },
})((props) => <Tabs {...props} variant="scrollable" scrollButtons="auto"  TabIndicatorProps={{ children: <span /> }} />);

const WeatherTab = withStyles((theme) => ({
  root: {
    paddingTop:"12px",
    textTransform: 'none',
    maxWidth:'none',
    color: '#1d1d1b',
    paddingBottom:0,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(-3),
    fontFamily: "proxima-nova, sans-serif !important",
    '&:focus': {
      opacity: 1,
    },
    "&:focus-visible": {
      backgroundColor: "hsl(208, 89%, 34%) !important",
    }
  },
}))((props) => <Tab disableRipple {...props} />);

  var currentTime = new Date();
  var sunSetTime = new Date();

  var noonTime = new Date(currentTime.getFullYear(),currentTime.getMonth(), currentTime.getDate(), 11, 45);
  if (typeof(day1.sunSet) != "undefined")
    sunSetTime = new Date(currentTime.getFullYear(),currentTime.getMonth(), currentTime.getDate(), day1.sunSet.substring(0, 2), day1.sunSet.substring(3));  

    return (
      error ? (
        <MenuContext.Provider value={{windValue, setWindValue, tempValue, setTempValue, handleChange, handleSettingChange}}>
          <Grid id="forecast" container style={{textAlign:"center"}}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
          <p style={{ color: "#bf0d0d" }}>
            Sorry, the {title} Forecast information is not available at
            the moment. Please check back later.
          </p>
          {props.mode==="jersey" && <div style={{textAlign:"center"}}><Button className="resendButton" onClick={() => setJerseyFeed(process.env.MET_JSYFORECAST) }>Try again</Button></div>}
          {props.mode==="guernsey" && <div style={{textAlign:"center"}}><Button className="resendButton" onClick={() => setGuernseyFeed(process.env.MET_GSYFORECAST) }>Try again</Button></div>}
          </Grid>
          </Grid>
          </MenuContext.Provider>
      ) : (
        <React.Fragment>
          {loading ? (
            // <div className={classes.root}><CircularProgress color="secondary"  /></div>
            <Loading />
          ) : (
            
            <MenuContext.Provider value={{windValue, setWindValue, tempValue, setTempValue, handleChange, handleSettingChange}}>

  <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" >
      <h1>
      {title+ ' '}
      {title === 'Jersey weather' && <span className="currentTemperature">Current </span>} <span className="currentTemperatureValue">{tempValue === 'Celsius' ? data.currentTemprature : data.currentTempratureFahrenheit}</span>
      </h1>                  
    </Grid>

            <Grid id="forecast" container style={{textAlign:"center"}}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <div className="tabArea">
                    {!mobileVP ?
                      <WeatherTabs value={tab} onChange={handleChange} aria-label="">
                        {tab===0 ? <WeatherTab label={<CurrentTab windMode={windValue} tempMode={tempValue} day={day1} Afternoon={currentTime > noonTime && currentTime < sunSetTime ? true : false} Evening={currentTime > sunSetTime ? true : false} last={false} />} /> : <WeatherTab label={<Tab2 windMode={windValue} tempMode={tempValue} day={day1} last={false} Afternoon={currentTime > noonTime && currentTime < sunSetTime ? true : false} Evening={currentTime > sunSetTime ? true : false}   />} />}
                        {tab===1 ? <WeatherTab label={<CurrentTab windMode={windValue} tempMode={tempValue} day={day2} Afternoon={false} currentTemp="0" last={false} Evening={false} />} /> : <WeatherTab label={<Tab2 windMode={windValue} tempMode={tempValue} day={day2}  Afternoon={false} Evening={false} last={false} />} />}
                        {tab===2 ? <WeatherTab label={<CurrentTab windMode={windValue} tempMode={tempValue} day={day3} currentTemp="0" last={false} Afternoon={false} Evening={false} />} /> : <WeatherTab label={<Tab2 windMode={windValue} tempMode={tempValue} day={day3} Afternoon={false} Evening={false} last={false} />} />}
                        {tab===3 ? <WeatherTab label={<CurrentTab windMode={windValue} tempMode={tempValue} day={day4} currentTemp="0" last={false} Afternoon={false} Evening={false} />} /> : <WeatherTab label={<Tab2 windMode={windValue} tempMode={tempValue} day={day4} Afternoon={false} Evening={false} last={false} />} />}
                        {tab===4 ? <WeatherTab label={<CurrentTab windMode={windValue} tempMode={tempValue} day={day5} currentTemp="0" last={false} Afternoon={false} Evening={false} />} /> : <WeatherTab label={<Tab2 windMode={windValue} tempMode={tempValue} day={day5} Afternoon={false} Evening={false} last={false} />} />}
                        {tab===5 ? <WeatherTab label={<CurrentTab windMode={windValue} tempMode={tempValue} day={day6} currentTemp="0" last={true} Afternoon={false} Evening={false} />} /> : <WeatherTab label={<Tab2 windMode={windValue} tempMode={tempValue} day={day6} Afternoon={false} Evening={false} last={true}  />} />}
                      </WeatherTabs>
                    :
                      <WeatherTabs value={tab} onChange={handleChange} aria-label="">
                        {tab===0 ? <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} last={false} day={day1} current={true} Afternoon={currentTime > noonTime && currentTime < sunSetTime ? true : false} Evening={currentTime > sunSetTime ? true : false} />} /> : <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} last={false} day={day1} Afternoon={currentTime > noonTime && currentTime < sunSetTime ? true : false} Evening={currentTime > sunSetTime ? true : false} />} />}
                        {tab===1 ? <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} Evening={false} Afternoon={false} last={false} day={day2} current={true} />} /> : <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} Afternoon={false} Evening={false} last={false} day={day2}  />} />}
                        {tab===2 ? <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} Evening={false} Afternoon={false} last={false} day={day3} current={true} />} /> : <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} Afternoon={false} Evening={false} last={false} day={day3}  />} />}
                        {tab===3 ? <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} Evening={false} Afternoon={false} last={false} day={day4} current={true} />} /> : <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} Afternoon={false} Evening={false} last={false} day={day4}  />} />}
                        {tab===4 ? <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} Evening={false} Afternoon={false} last={false} day={day5} current={true} />} /> : <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} Afternoon={false} Evening={false} last={false} day={day5}  />} />}
                        {tab===5 ? <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} Evening={false} Afternoon={false} last={false} day={day6} current={true} />} /> : <WeatherTab label={<MobileTab windMode={windValue} tempMode={tempValue} Afternoon={false} Evening={false} last={false} day={day6}  />} />}
                      </WeatherTabs>
                    }
                    <div className="redLine"/>
                    </div>
                    
                    {tab=== 0 && <MobilePanel  currentMobileTab={tab} currentTemp={data.currentTemprature} uv={day1.uvIndex} description={day1.dayToolTip}/>}
                    {tab=== 1 && <MobilePanel currentMobileTab={tab} currentTemp={data.currentTemprature} uv={day2.uvIndex} description={day2.dayToolTip}/>}
                    {tab=== 2 && <MobilePanel currentMobileTab={tab} currentTemp={data.currentTemprature} uv={day3.uvIndex} description={day3.dayToolTip}/>}
                    {tab=== 3 && <MobilePanel currentMobileTab={tab} currentTemp={data.currentTemprature} uv={day4.uvIndex} description={day4.dayToolTip}/>}
                    {tab=== 4 && <MobilePanel currentMobileTab={tab} currentTemp={data.currentTemprature} uv={day5.uvIndex} description={day5.dayToolTip}/>}
                    {tab=== 5 && <MobilePanel currentMobileTab={tab} currentTemp={data.currentTemprature} uv={day6.uvIndex} description={day6.dayToolTip}/>}
    
                    <div id="tabBody">                  
                      <TabPanel value={tab} index={0}>
                        <Grid container spacing={3}>
                        {currentTime < noonTime &&
                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day1} currentTemp={data.currentTemprature} currentTempF={data.currentTempratureFahrenheit} issuetime={data.issuetime}  mode="Morning" today={true} first={true} /> 
                          </Grid>
                        }                      
                        {currentTime < sunSetTime && 
                          <Grid item xs={12} sm={12} md={4} lg={4}>
                          <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day1} today={true} issuetime={data.issuetime} mode="Afternoon" first={currentTime >= noonTime  ? true : false} />
                          </Grid>
                        }
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day1} today={true} issuetime={data.issuetime} mode="Night" first={currentTime >= sunSetTime  ? true : false} />
                        </Grid>
                      </Grid>                  
                      </TabPanel>
                      <TabPanel value={tab} index={1}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                          <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day2} today={false} issuetime={data.issuetime} mode="Morning" first={true}/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                          <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day2} today={false} issuetime={data.issuetime} mode="Afternoon" />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                          <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day2} today={false} issuetime={data.issuetime} mode="Night" />
                        </Grid>
                      </Grid>
                      </TabPanel>
                      <TabPanel value={tab} index={2}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day3} today={false} issuetime={data.issuetime} mode="Morning" first={true}/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day3} today={false} issuetime={data.issuetime} mode="Afternoon" />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day3} today={false} issuetime={data.issuetime} mode="Night" />
                        </Grid>
                        </Grid>
                      </TabPanel>
                      <TabPanel value={tab} index={3}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day4} today={false} issuetime={data.issuetime} mode="Morning" first={true}/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day4} today={false} issuetime={data.issuetime} mode="Afternoon" />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day4} today={false} issuetime={data.issuetime} mode="Night" />
                        </Grid>
                        </Grid>
                      </TabPanel>
                      <TabPanel value={tab} index={4}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day5} today={false} issuetime={data.issuetime} mode="Morning" first={true}/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day5} today={false} issuetime={data.issuetime} mode="Afternoon" />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day5} today={false} issuetime={data.issuetime} mode="Night" />
                        </Grid> 
                        </Grid>
                      </TabPanel>
                      <TabPanel value={tab} index={5}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day6} today={false} issuetime={data.issuetime} mode="Morning" first={true}/>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>                    
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day6} today={false} issuetime={data.issuetime} mode="Afternoon" />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TabDetail title={title} windMode={windValue} tempMode={tempValue} day={day6} today={false} issuetime={data.issuetime} mode="Night" />
                        </Grid>
                        </Grid>
                      </TabPanel>
                        
                      <section style={{padding:"24px 14px 10px 24px"}}>
                      <Grid container>

                      {settingsMQ &&
       
                      <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:'right', marginBottom:'20px'}}>
                            <Settings/>
                        </Grid>
                      }
       
                        <Grid item xs={12} sm={12} md={6} lg={6}  style={{textAlign:'left'}}>
                          Forecast updated {data.forecastDate} {data.forecastTime}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign:'right'}}>
                        {!settingsMQ &&
                            <Settings/>
                         }
                        </Grid>
                      </Grid>
                      </section>
                    </div>
                </Grid>
            </Grid>
            <ForecastPrintable data={data} loading={loading}/>
            <BlockSection title={title}/>
            </MenuContext.Provider>
          )}

        </React.Fragment>
      ))}
    
export default Homepage

